/**
 * synotis-support#8 — Dernière affaire saisie.
 *
 * Après une saisie (allocation au planning ou imputation), l'affaire est
 * mémorisée dans le navigateur ; la saisie suivante la propose par défaut,
 * planning et imputation confondus. Pur confort : la valeur n'est reprise que
 * si elle figure dans la liste offerte à l'écran (droits, affaire archivée ou
 * en planification uniquement), sinon le champ reste vide comme avant.
 */

const STORAGE_KEY = 'synolog_last_affaire';

export function rememberLastAffaire(affaireId) {
  if (!affaireId) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, affaireId);
  } catch {
    /* stockage indisponible (navigation privée) : on ne mémorise rien */
  }
}

/** Identifiant de la dernière affaire saisie s'il figure dans `affaires`, sinon ''. */
export function lastAffaireIn(affaires) {
  let id = null;
  try {
    id = window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return '';
  }
  if (!id || !Array.isArray(affaires)) return '';
  return affaires.some((a) => a?.id === id) ? id : '';
}
